import React from 'react';
import cn from 'classnames/bind';
import { SportEvent, SportEventState } from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { useInView } from 'react-intersection-observer';

import { StageBadge } from '../StageBadge/StageBadge';
import { TeamsEventMeta } from '../TeamsEventMeta/TeamsEventMeta';

import styles from './EventContent.module.css';

interface EventContentProps {
    item: SportEvent;
    eventState: SportEventState;
    contentAction: React.ReactNode;
    onShow?: () => void;
}

export const EventContent: React.FC<EventContentProps> = ({
    item,
    eventState,
    onShow,
    contentAction,
}) => {
    const { ref: inViewRef } = useInView({
        onChange(inView: boolean) {
            if (inView) {
                onShow?.();
            }
        },
        threshold: 0.8,
    });

    return (
        <div className={styles.root} ref={inViewRef}>
            <div className={styles.eventHeader}>
                <StageBadge
                    eventState={eventState}
                    startTime={item.startTime}
                    endTime={item.endTime}
                />
                {item.competition && (
                    <span className={styles.competitionText}>
                        {item.competition.combinedSportCompetitionName}
                    </span>
                )}
            </div>
            <EventBody item={item} />
            {contentAction}
        </div>
    );
};

const EventBody: React.FC<{ item: SportEvent }> = ({ item }) => {
    const commentStyle = cn(styles.eventComment, styles.truncatedText);

    if (item.typename === 'TeamsSportEvent') {
        return (
            <div className={styles.eventBlock}>
                <TeamsEventMeta sportEvent={item} />
                <p className={commentStyle}>{item.comment}</p>
            </div>
        );
    }

    return (
        <div className={styles.eventBlock}>
            <h1 className={cn(styles.eventTitle, styles.truncatedText)}>{item.title}</h1>

            {item.comment && <p className={commentStyle}>{item.comment}</p>}
        </div>
    );
};
